
// @ts-nocheck
/* eslint-disable */
import { defineComponent, computed, provide, nextTick, toRefs } from 'vue'
import { UPDATE_MODEL_EVENT, CHANGE_EVENT } from '@/components/utils/constants'
import { isValidComponentSize } from '@/components/utils/validators'
import { useCheckboxGroup } from './useCheckbox'

import type { PropType } from 'vue'

export default defineComponent({
  name: 'MsCheckboxGroup',

  props: {
    modelValue: {
      type: [Object, Boolean, Array],
      default: () => undefined
    },
    disabled: Boolean,
    min: {
      type: Number,
      default: undefined
    },
    max: {
      type: Number,
      default: undefined
    },
    size: {
      type: String as PropType<ComponentSize>,
      validator: isValidComponentSize
    },
    fill: {
      type: String,
      default: undefined
    },
    textColor: {
      type: String,
      default: undefined
    }
  },

  emits: [UPDATE_MODEL_EVENT, CHANGE_EVENT],

  setup (props, ctx) {
    const { elFormItemSize, ELEMENT } = useCheckboxGroup()
    const checkboxGroupSize = computed(() => props.size || elFormItemSize.value || ELEMENT.size)

    const changeEvent = value => {
      ctx.emit(UPDATE_MODEL_EVENT, value)
      nextTick(() => {
        ctx.emit(CHANGE_EVENT, value)
      })
    }

    const modelValue = computed({
      get () {
        return props.modelValue
      },
      set (val) {
        changeEvent(val)
      }
    })

    provide('CheckboxGroup', {
      name: 'MsCheckboxGroup',
      modelValue,
      ...toRefs(props),
      checkboxGroupSize,
      changeEvent
    })
  }
})
